import React, { useEffect, useState } from 'react';
import { Eye } from 'lucide-react';

const VisitorCounter = () => {
  const [visitorCount, setVisitorCount] = useState(0);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const trackAndGetCount = async () => {
      try {
        const API_URL = process.env.REACT_APP_BACKEND_URL;
        
        // Check if visitor has been tracked in this session
        const hasTracked = sessionStorage.getItem('visitor_tracked');
        
        if (!hasTracked) {
          // Track new visitor
          await fetch(`${API_URL}/api/visitors/track`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
          });
          sessionStorage.setItem('visitor_tracked', 'true');
        }
        
        // Get current visitor count
        const response = await fetch(`${API_URL}/api/visitors/count`);
        const data = await response.json();
        setVisitorCount(data.total_visitors || 0);
        setIsLoading(false);
      } catch (error) {
        console.error('Error fetching visitor count:', error);
        setIsLoading(false);
      }
    };

    trackAndGetCount();
  }, []);

  const formatNumber = (num) => {
    return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  };

  return (
    <div className="flex items-center justify-center gap-2 text-gray-600">
      <Eye className="h-4 w-4" />
      <span className="text-sm">
        {isLoading ? (
          'Loading...'
        ) : (
          <>
            <span className="font-semibold text-blue-600">{formatNumber(visitorCount)}</span>
            {' '}Visitors
          </>
        )}
      </span>
    </div>
  );
};

export default VisitorCounter;
